import { Component, OnInit, Input } from '@angular/core';
import { BaseEnvironmentService } from '../../../core/services/base-environment.service';

@Component({
  selector: 'base-unbranded-wrapper',
  templateUrl: './base-unbranded-wrapper.component.html',
})
export class BaseUnbrandedWrapperComponent implements OnInit {
  @Input() isResetPasswordPage = false;

  logo = '';
  logoSmall = '';

  constructor(private environmentService: BaseEnvironmentService) {}

  ngOnInit() {
    this.logo = this.environmentService.getLocalValue('application').logoSystemPage;
    this.logoSmall = this.environmentService.getLocalValue('application').logoSystemPageSmall;
  }
}
